import 'pages/images/image-gallery.tag'
riot.tag2('images-manager', '  <div class="main-container">\n    <div class="col-md-12">\n      <div class="row" if="{!notFound}">\n        <div class="col-sm-10 col-xs-12">\n          <image-gallery name="gallery" dblclick="{dblclick}" autoselect="{autoselect}"></image-gallery>\n        </div>\n      </div>\n    </div>\n  </div>\n', '.main-container { margin: 10px; }', '', function(opts) {
'use strict';

var self = this;

self.state = {};
self.state.section = '';

self.on('update', function () {
    if (!self.state.section || self.state.section != localStorage.getItem('CMS_section')) {
        self.update();
        self.state.section = localStorage.getItem('SE_section');
        self.state.limit = self.tags.gallery.pages.limit;
        self.state.offset = 0;

        self.tags.gallery.update({ params: self.state });
        self.tags.gallery.reload();

        self.update();
    }
});

observable.on('images-page-change', function (params) {
    self.state = params;
});

self.autoselect = function (item) {
    window.top.opener.CKEDITOR.tools.callFunction(self.callback, item.imageUrl);
    window.top.close();
    window.top.opener.focus();
};

self.dblclick = function (e) {
    self.autoselect(e.item.row);
};

self.menuSelect = function (e) {
    riot.route('/imageUpload/' + e.target.value);
};

self.on('mount', function () {
    //riot.route.exec()
    self.callback = riot.route.query();
    self.callback = self.callback['CKEditorFuncNum'];
});
});


// WEBPACK FOOTER //
// ./pages/images/images-manager.tag